import util from '@bmp-vue/core/api/util'

const controller = 'Autenticacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post(controller + '/AccessToken', dto)
  },
  Logout: function () {
    return util.Axios.Delete(controller + '/AccessToken')
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshToken', dto)
  },
  RevokeRefreshToken: function (token) {
    return util.Axios.Delete(controller + 'RevokeRefreshToken', token)
  },
  JumpCloudAuthorizeUrl: function () {
    return process.env.VUE_APP_ROOT_API + controller + '/JumpCloud/Authorize'
  },
  JumpCloudToken: function (codigo) {
    return util.Axios.Post(controller + '/JumpCloud/Token', { Codigo: codigo })
  }
})
